import { createContext, useContext, type ReactNode } from "react";

export type Language = "en" | "zh-CN";

const zh: Record<string, string> = {
  "Agents with People": "Agents with People · 智能体与人协作",
  "Run mode": "运行模式",
  "Recorded Replay": "录制回放",
  "Scripted Fallback": "脚本回退",
  "Live Agent": "实时智能体",
  "Runtime": "运行时",
  "Project menu": "项目菜单",
  "Export state": "导出状态",
  "Import state": "导入状态",
  "Reset guided demo": "重置引导演示",
  "Calls the selected provider through the local gateway.": "通过本地网关调用所选模型服务。",
  "Runs a deterministic fallback. No model call is occurring.": "运行确定性的脚本回退，不会调用模型。",
  "key ready": "密钥可用",
  "no server key": "未设置密钥",
  "session key": "本次会话密钥",
  "Environment key": "环境密钥",
  "Model API settings": "模型 API 设置",
  "Configure model API": "设置模型 API",
  "Use one Provider and model for every Agent role in this run.": "本次运行中的所有智能体角色共用一个模型服务与模型。",
  "Provider": "模型服务",
  "Model": "模型",
  "API key": "API 密钥",
  "Leave blank to reuse the key already available to the local Gateway.": "留空即可继续使用本地网关中已有的密钥。",
  "The key is sent only to the local Gateway for verification. It is never written to browser storage, exports, or project files.": "密钥只会发送给本地网关进行验证，不会写入浏览器存储、导出内容或项目文件。",
  "Cancel": "取消",
  "Test connection & use": "测试连接并使用",
  "Checking connection…": "正在检查连接…",
  "Connection verified. Live Agent mode is ready.": "连接验证成功，实时智能体模式已可用。",
  "Enter an API key or reuse an existing Gateway key.": "请输入 API 密钥，或复用网关中已有的密钥。",
  "Close model API settings": "关闭模型 API 设置",
  "Choose language": "选择语言",
  "English": "English",
  "Chinese": "中文",
  "User Workspace": "用户工作区",
  "Adapt locally": "本地调整",
  "KPR Bridge": "KPR 知识协作",
  "Collaborate through knowledge": "以知识为媒介协作",
  "Developer Control Plane": "开发者控制平面",
  "Govern reliably": "可靠治理",
  "Guided story": "引导流程",
  "Describe a local need": "描述本地需求",
  "Inspect the Agent plan": "检查智能体计划",
  "Approve the User Overlay": "批准用户覆写层",
  "Verify and attest knowledge": "验证并确认知识",
  "Create and submit the KPR": "创建并提交 KPR",
  "Understand knowledge impact": "理解知识影响",
  "Shape the Integration Contract": "制定集成契约",
  "Synthesize and verify": "实现并验证",
  "Adopt under human governance": "由人治理并采纳",
  "Principle lens": "原则透镜",
  "Agent First": "Agent First · Agent 优先",
  "Human Governed": "Human Governed · 由人治理",
  "Knowledge before Code": "知识先于代码",
  "Evidence before Adoption": "证据先于采纳",
  "Project-owned Implementation": "项目掌握实现权",
  "Click to reveal the object or human gate that embodies each principle.": "点击查看体现该原则的系统对象或人工关卡。",
  "Agentic Software": "Agentic Software · 智能体软件",
  "Combine software knowledge with user knowledge.": "让软件知识与用户知识结合。",
  "The User-side Agent may change your reversible local realization. It cannot change the public project.": "用户侧智能体可以修改可回滚的本地实现，但不能修改公共项目。",
  "Software knowledge layers": "软件知识层",
  "Developer intent": "开发者意图",
  "Reference core": "参考实现内核",
  "User realization": "用户本地实现",
  "Reference application": "参考应用",
  "Research Brief": "研究简报",
  "local overlay active": "本地覆写层已启用",
  "reference behavior": "参考实现行为",
  "Reference behavior": "参考行为",
  "User-side Agent panel": "用户侧智能体面板",
  "User-side Agent": "用户侧智能体",
  "Local knowledge partner": "本地知识伙伴",
  "R1 · reversible": "R1 · 可回滚",
  "Agent-readable software contract": "Agent 可读的软件契约",
  "capabilities": "项能力",
  "surfaces": "个可变界面",
  "invariants": "条不变量",
  "Protected": "受保护",
  "User-local": "用户本地",
  "Project-controlled": "项目控制",
  "contributable": "可贡献",
  "not contributed": "不参与贡献",
  "reversible": "可回滚",
  "irreversible": "不可回滚",
  "Describe what should work differently for you": "描述你希望软件如何为你改变",
  "Ask User-side Agent": "询问用户侧智能体",
  "Agent is preparing a bounded proposal…": "智能体正在准备有边界的方案…",
  "Plan preview": "计划预览",
  "not applied": "尚未应用",
  "Presentation": "呈现方式",
  "Conclusion → context → evidence": "结论 → 背景 → 证据",
  "Sources": "来源",
  "Preserved": "保留",
  "Public core": "公共核心",
  "Unchanged": "不变",
  "Memory": "记忆",
  "Only after confirmation": "仅在确认后保存",
  "Human gate": "人工审批点",
  "Approve local overlay": "批准本地覆写层",
  "Run local verifiers": "运行本地验证器",
  "Restore reference behavior": "恢复参考行为",
  "Create KPR draft": "创建 KPR 草稿",
  "Independent evidence": "独立证据",
  "Conclusion": "结论",
  "Evidence": "证据",
  "Context": "背景",
  "Limitations": "局限性",
  "Research Brief preview": "研究简报预览",
  "Research Brief · 04 min": "研究简报 · 约 4 分钟",
  "Knowledge-based Pull Request": "Knowledge-based Pull Request（KPR）",
  "No Knowledge-based Pull Request yet.": "还没有基于知识的 Pull Request。",
  "Verify a local User Overlay and let the contributor attest the extracted knowledge first.": "请先验证本地用户覆写层，并由贡献者签认提取出的知识。",
  "Return to User Workspace": "返回用户工作区",
  "Exchange knowledge, intent, and evidence—not just a patch.": "交换知识、意图与证据，而不只是一份代码补丁。",
  "The local implementation is evidence. The project decides what knowledge to adopt and how to implement it.": "本地实现是一种证据；项目决定采纳哪些知识，以及如何实现。",
  "KPR views": "KPR 视图",
  "brief": "决策简报",
  "knowledge": "知识",
  "provenance": "来源脉络",
  "evidence": "证据",
  "raw": "原始数据",
  "impact": "影响",
  "integration": "集成",
  "result": "结果",
  "Export Markdown": "导出 Markdown",
  "Export JSON": "导出 JSON",
  "sec": "秒",
  "Decision brief": "决策简报",
  "Decision": "决策",
  "Worth exploring; narrow scope": "值得探索，但需缩小范围",
  "Why now": "为何现在",
  "Verified friction in a real local workflow": "真实本地流程中的摩擦已得到验证",
  "Value": "价值",
  "Decision first without losing evidence": "让决策优先，同时不丢失证据",
  "Scope": "范围",
  "Research Brief; opt-in candidate": "研究简报；选择性启用",
  "Risk": "风险",
  "Source loss or silent default change": "来源丢失或默认行为被静默修改",
  "linked artifacts": "项关联材料",
  "Policy conflicts": "策略冲突",
  "1 default-stability tension": "1 项默认稳定性冲突",
  "Open questions": "开放问题",
  "unresolved at submission": "项在提交时尚未解决",
  "Current human decision": "当前人工决策",
  "Proceed to Knowledge Review, or request more knowledge?": "进入知识审查，还是请求更多知识？",
  "Primary tension": "主要张力",
  "User asks to remember a preference. Project Policy forbids silently changing the public default.": "用户希望记住个人偏好，但项目策略禁止静默修改公共默认值。",
  "Knowledge Diff": "知识差异",
  "reviewable claims": "条可审查主张",
  "Contributor wording": "贡献者表述",
  "Human-authored": "人类撰写",
  "Agent-extracted · Human-corrected · Human-attested": "Agent 提取 · 人工修正 · 人工签认",
  "Agent-extracted · Human-attested": "Agent 提取 · 人工签认",
  "Agent-extracted · Human-corrected": "智能体提取 · 人工修正",
  "Agent-extracted · awaiting human review": "智能体提取 · 等待人工审查",
  "View linked evidence": "查看关联证据",
  "Knowledge Provenance": "知识溯源",
  "Origin is not authority": "来源不等于权威",
  "Human request": "人类需求",
  "Original need and local context.": "原始需求与本地背景。",
  "Agent extraction": "智能体提取",
  "Structured claims, explicitly marked as inferred.": "结构化主张，并明确标记推断内容。",
  "Local proof": "本地证明",
  "Verifier evidence and a reversible overlay.": "验证器证据与可回滚覆写层。",
  "Human attestation": "人工签认",
  "Contributor confirms meaning and scope.": "贡献者确认含义与范围。",
  "Claim-linked Evidence": "主张关联证据",
  "Evidence says what it supports—and what it cannot prove": "证据同时说明它支持什么，以及不能证明什么",
  "Evidence focus": "证据焦点",
  "All KPR evidence": "全部 KPR 证据",
  "Focused Claim:": "当前主张：",
  "No evidence is linked to this Claim. Request evidence before synthesis.": "该主张没有关联证据，请在实现前请求证据。",
  "Produced by": "产生者",
  "Supports": "支持",
  "Cannot prove": "不能证明",
  "Replay": "回放",
  "Replayable": "可回放",
  "Not replayable": "不可回放",
  "Human confirmation": "人工确认",
  "Confirmed": "已确认",
  "Verifier-produced; human review pending": "由验证器产生；等待人工审查",
  "Privacy / license": "隐私 / 许可",
  "Failed attempt retained": "保留失败尝试",
  "Required before submission.": "提交前必须完成。",
  "Contributor correction recorded.": "项贡献者修正已记录。",
  "Optional contributor correction recorded.": "项可选的贡献者修正已记录。",
  "Review every relevant Claim. Edit wording only when it needs correction, then attest explicitly.": "请审阅所有相关知识主张；只有表述确需修正时才编辑，然后由你显式签认。",
  "Attest reviewed knowledge": "确认已审查知识",
  "Private implementation": "私有实现",
  "evidence, not authority": "是证据，不是权威",
  "Visible to Project Agent: no": "项目智能体可见：否",
  "Submission gate": "提交关卡",
  "Contributor correction": "贡献者修正",
  "Attestation": "签认",
  "Acceptance criteria": "验收标准",
  "Invariants": "不变量",
  "Privacy scan": "隐私扫描",
  "Run privacy scan": "运行隐私扫描",
  "Submit KPR": "提交 KPR",
  "Run Knowledge Gate": "运行知识准入检查",
  "System notifications": "系统通知",
  "Dismiss notification": "关闭通知",
  "Agentic Runtime": "Agentic Runtime · 智能体运行时",
  "Inspectable execution, not hidden magic.": "可检查的执行，而不是隐藏的魔法。",
  "Close Runtime Inspector": "关闭运行时检查器",
  "Live events returned by the local Provider Gateway.": "由本地模型网关返回的实时事件。",
  "Deterministic fallback events. No model request.": "确定性的回退事件，不调用模型。",
  "User-side": "用户侧",
  "Maintainer-side": "维护者侧",
  "Project": "项目",
  "Policy": "策略",
  "Action": "行动",
  "Proof": "证明",
  "What could the Agent see?": "智能体可以看到什么？",
  "What was allowed or blocked?": "哪些行为被允许或阻止？",
  "What did it actually propose or call?": "它实际提出或调用了什么？",
  "What supports success or failure?": "什么证据支持成功或失败？",
  "What governed state persists?": "哪些受治理状态会被保留？",
  "Status": "状态",
  "Skill": "技能",
  "Provider calls": "模型调用",
  "Tool budget": "工具预算",
  "Tokens / cap": "Token / 上限",
  "Termination:": "终止原因：",
  "Cancel live request": "取消实时请求",
  "run yet.": "尚无运行记录。",
  "Run the corresponding Agent in its workspace. Runtime events will appear here.": "请在相应工作区运行智能体，运行事件会显示在这里。",
  "Do smaller language models belong in local research workflows?": "小型语言模型是否适合本地研究流程？",
  "When should a research team prefer a smaller local model over a hosted frontier model?": "研究团队应在什么情况下优先选择本地小模型，而不是托管的前沿模型？",
  "Use a smaller local model when privacy, predictable cost, or offline availability matters more than frontier reasoning quality; keep a hosted model available for the hardest synthesis and verification tasks.": "当隐私、可预测成本或离线可用性比前沿推理质量更重要时，应使用本地小模型；同时为最困难的综合与验证任务保留托管模型。",
  "Research teams increasingly mix local and hosted models. The decision is not a single quality ranking: it depends on data sensitivity, latency, hardware, task difficulty, and the cost of verification.": "研究团队越来越多地混合使用本地与托管模型。这并不是单一的质量排名问题，而取决于数据敏感性、延迟、硬件、任务难度以及验证成本。",
  "Local inference can keep sensitive prompts inside a controlled environment.": "本地推理可以让敏感提示留在受控环境中。",
  "Hosted frontier models remain stronger on difficult synthesis tasks in the reference evaluation.": "在参考评估中，托管的前沿模型在困难的综合任务上仍然更强。",
  "The total cost depends on utilization and local hardware, not token price alone.": "总成本取决于利用率与本地硬件，而不仅是 Token 单价。",
  "Project privacy notes": "项目隐私说明",
  "Reference evaluation v0.1": "参考评估 v0.1",
  "Cost model assumptions": "成本模型假设",
  "The reference evaluation is illustrative, not a comprehensive model benchmark.": "参考评估仅用于说明，并不是全面的模型基准。",
  "Local deployment still requires security updates and operational expertise.": "本地部署仍需要安全更新与运维专业能力。",
  "Summary layout": "摘要布局",
  "Reference visual theme": "参考视觉主题",
  "Confirmed preference memory": "已确认的偏好记忆",
  "interface": "界面",
  "preference": "偏好",
  "Put the conclusion first, keep the supporting evidence and sources visible, preserve the light and simple interface, and remember this as my preference.": "把结论放在最前面，同时保留支持证据与来源，保持轻量简洁的界面，并在我确认后记住这个偏好。",
  "Optional conclusion-first research briefs": "可选的结论优先研究简报",
  "Research Brief readers may need the conclusion before the supporting context.": "研究简报的读者可能需要先看到结论，再阅读支持背景。",
  "The current brief makes readers traverse context before they see the decision-relevant conclusion.": "当前简报要求读者先读完背景，才能看到与决策相关的结论。",
  "A reader can choose a conclusion-first layout with supporting evidence immediately after it.": "读者可以选择结论优先布局，并在结论之后紧接支持证据。",
  "Changing the layout must not remove evidence or source links.": "改变布局不得移除证据或来源链接。",
  "Remember the conclusion-first layout after the user explicitly confirms it.": "仅在用户明确确认后记住结论优先布局。",
  "Do not persist the layout preference.": "不要持久保存布局偏好。",
  "Prove the behavior in a reversible User Overlay before proposing a public capability.": "先在可回滚的用户覆写层中验证该行为，再提出公共能力。",
  "Every conclusion remains linked to visible supporting evidence and sources.": "每项结论都继续关联可见的支持证据与来源。",
  "Should the project offer conclusion-first summaries as an optional public capability?": "项目是否应将结论优先摘要作为可选的公共能力？",
  "Users can opt into a conclusion-first layout.": "用户可以选择启用结论优先布局。",
  "Evidence and source links remain visible.": "证据与来源链接保持可见。",
  "The preference is saved only after explicit confirmation.": "只有在明确确认后才保存偏好。",
  "Conclusion renders before evidence when the option is enabled.": "启用选项后，结论会显示在证据之前。",
  "All source links remain attached.": "所有来源链接继续保持关联。",
  "The existing public default remains unchanged.": "现有公共默认值保持不变。",
  "Removing the option restores reference behavior.": "移除该选项会恢复参考行为。",
  "Do not make conclusion-first the public default.": "不要把结论优先设为公共默认值。",
  "Do not change non-Research-Brief applications.": "不要改变研究简报之外的应用。",
  "Do not adopt the contributor's local code directly.": "不要直接采纳贡献者的本地代码。",
  "A conclusion-only layout was rejected because it hid evidence and violated the source invariant.": "仅显示结论的布局已被拒绝，因为它隐藏了证据并违反来源不变量。",
  "Should the capability remain experimental until more document types are evaluated?": "在评估更多文档类型前，该能力是否应保持实验状态？",
  "Reversible JSON overlay changing layout and confirmed preference behavior.": "用于调整布局与已确认偏好行为的可回滚 JSON 覆写层。",
  "Optional summary order": "可选摘要顺序",
  "Adds a conclusion-first path while leaving the reference default unchanged.": "增加结论优先路径，同时保持参考默认值不变。",
  "Settings and presentation control": "设置与呈现控制",
  "Adds an explicit opt-in control and changes section order only when enabled.": "增加明确的选择性启用控件，仅在启用时改变章节顺序。",
  "Preference persistence": "偏好持久化",
  "Persists only after explicit confirmation and remains removable.": "仅在明确确认后保存，并且始终可以移除。",
  "Local preference and contribution boundary": "本地偏好与贡献边界",
  "Preference memory remains user-local; only human-selected claims enter the KPR.": "偏好记忆保留在用户本地；只有人工选择的主张进入 KPR。",
  "Document-type boundary": "文档类型边界",
  "Evidence covers Research Brief only; other document types remain unknown.": "证据仅覆盖研究简报；其他文档类型仍属未知。",
  "Rendering and Agent-call cost": "渲染与智能体调用成本",
  "The local layout change is bounded; any Live Agent analysis remains within the configured call and token budgets.": "本地布局变更有明确边界；实时智能体分析仍受已配置的调用与 Token 预算约束。",
  "Source links and claim support": "来源链接与主张支持",
  "The source-preservation invariant must remain visible in every layout.": "来源保留不变量必须在每种布局中保持可见。",
  "Explain opt-in behavior and reset": "说明选择性启用行为与重置方式",
  "User and maintainer documentation must state the default, confirmation boundary, and rollback path.": "用户与维护者文档必须说明默认值、确认边界与回滚路径。",
  "Experimental opt-in rollout": "实验性选择启用发布",
  "Ship behind an experimental setting with a one-click reset path.": "通过实验性设置发布，并提供一键重置路径。",
  "Unsupported conclusion verifier": "无证据结论验证器",
  "Reject a conclusion block that has no linked evidence.": "拒绝没有关联证据的结论块。",
  "Offer conclusion-first summaries as an experimental, opt-in capability for Research Brief documents only.": "仅为研究简报提供实验性的、选择性启用的结论优先摘要能力。",
  "The local evidence supports one document type and does not justify a public default change.": "本地证据只支持一种文档类型，不足以证明应改变公共默认值。",
  "The local scenario and attestation establish a credible user problem.": "本地场景与人工签认表明用户问题可信。",
  "The claim is human-attested and linked to local evidence or a protected invariant.": "该知识主张已经人工签认，并关联本地证据或受保护不变量。",
  "In this Research Brief scenario, the current layout delays the decision-relevant conclusion until after the supporting context.": "在这个研究简报场景中，当前布局将与决策相关的结论放在支持背景之后，导致结论出现得过晚。",
  "I confirm that these claims accurately represent my request and local verification. I reviewed the submission scope and excluded private information.": "我确认这些主张准确表达了我的需求与本地验证结果；我已审查提交范围并排除私人信息。",
  "Verified in the Research Brief reference scenario only.": "仅在研究简报参考场景中得到验证。",
  "Agent proposal is ready. Human approval is still required.": "智能体方案已准备好，仍需人工批准。",
  "Impact analysis is a project-side inference, not a Maintainer decision.": "影响分析是项目侧推断，并非维护者决策。",
  "Project candidate generated. Verifiers, not the Agent message, determine completion.": "项目候选实现已生成；是否完成由验证器判断，而不是由智能体消息判断。",
  "No Agent proposal is available to approve.": "没有可供批准的智能体方案。",
  "Human approved a reversible local overlay.": "人已批准可回滚的本地覆写层。",
  "All local verifiers passed.": "所有本地验证器均已通过。",
  "A local verifier failed; the KPR cannot be created.": "本地验证器失败，无法创建 KPR。",
  "User Overlay removed. Reference behavior was restored from the checkpoint.": "用户覆写层已移除，并从检查点恢复参考实现行为。",
  "Verify the local change before creating a KPR.": "创建 KPR 前请先验证本地变更。",
  "KPR draft created. Review the Agent extraction before Human Attestation; wording changes are optional.": "KPR 草稿已创建；人工签认前请审阅 Agent 提取内容，文字修正不是必需条件。",
  "Human Attestation recorded after explicit Contributor review.": "贡献者显式审阅后，人工签认已记录。",
  "Privacy and secret scan passed.": "隐私与密钥扫描已通过。",
  "Submission blocked by privacy findings.": "提交被隐私扫描结果阻止。",
  "Run and pass the privacy scan before submission.": "提交前请运行并通过隐私扫描。",
  "KPR submitted to the Knowledge Gate.": "KPR 已提交至知识准入检查。",
  "Knowledge Gate passed.": "知识准入检查已通过。",
  "Maintainer approved the Knowledge Integration Contract.": "维护者已批准知识集成契约。",
  "Project candidate passed every Contract verifier.": "项目候选实现已通过所有契约验证器。",
  "Verifier failure: generation is not completion. Roll back or revise.": "验证器失败：生成不等于完成，请回滚或修订。",
  "Project candidate rolled back to the checkpoint.": "项目候选实现已回滚到检查点。",
  "Only a verified candidate can be adopted.": "只能采纳已验证的候选实现。",
  "Maintainer adopted the verified candidate. Human governance is complete.": "维护者已采纳通过验证的候选实现，人工治理流程完成。",
  "Connection check failed.": "连接检查失败。",
  "No key is configured for the active Provider. Open the model API settings, or use Replay or Scripted mode.": "当前模型服务未配置密钥。请打开模型 API 设置，或使用记录回放与脚本模式。",
  "Sources stay visible": "来源始终可见",
  "Public defaults remain stable": "公共默认值保持稳定",
  "No KPR has passed the Knowledge Gate.": "还没有 KPR 通过知识准入检查。",
  "The Developer Control Plane begins with reviewable, human-attested knowledge—not an unsolicited code diff.": "开发者控制平面从可审查、经人工签认的知识开始，而不是从未经请求的代码 diff 开始。",
  "Review KPR gate": "审查 KPR 关卡",
  "Start guided story": "开始引导演示",
  "KPR Developer Workspace": "KPR 开发者工作区",
  "Decide knowledge before reviewing implementation.": "先决定知识，再审查实现。",
  "Review order: Decision → Knowledge → Impact → Evidence → Trace → Code.": "审查顺序：决策 → 知识 → 影响 → 证据 → 轨迹 → 代码。",
  "Maintainer-side Agent": "维护者侧智能体",
  "Project Agent": "项目智能体",
  "Maintainer": "维护者",
  "understand · no write authority": "负责理解 · 无写入权限",
  "implement · no merge authority": "负责实现 · 无合并权限",
  "decide · approve · adopt": "负责决策 · 批准 · 采纳",
  "KPR Inbox": "KPR 收件箱",
  "claims": "条主张",
  "Hide failure laboratory": "隐藏失败实验室",
  "Open failure laboratory": "打开失败实验室",
  "Failure Laboratory": "失败实验室",
  "Expected failure is a system feature": "预期失败也是系统能力",
  "These checks run on isolated copies. They do not damage the active KPR.": "这些检查在隔离副本上运行，不会损坏当前 KPR。",
  "Expected:": "预期：",
  "Observed:": "观察到：",
  "failure controls behaved as specified": "项失败控制均按设计工作",
  "30-second decision": "30 秒决策",
  "Worth solving; scope must be narrowed.": "值得解决，但必须缩小范围。",
  "human decision needed": "需要人工决策",
  "The contributor proved a local need and preserved sources. The evidence does not justify changing the public default or generalizing beyond Research Brief.": "贡献者证明了本地需求并保留了来源，但现有证据不足以支持修改公共默认值，也不足以推广到研究简报之外。",
  "Know": "已知",
  "Infer": "推断",
  "Unknown": "未知",
  "Conclusion-first helps this workflow.": "结论优先有助于当前工作流。",
  "Sources remain visible.": "来源保持可见。",
  "The overlay is reversible.": "覆写层可以回滚。",
  "An optional public feature may help others.": "可选的公共功能可能帮助其他人。",
  "Preference persistence needs a confirmation gate.": "保存偏好需要确认关卡。",
  "Behavior on other document types.": "在其他文档类型上的行为。",
  "Stable-release demand.": "对稳定版本的需求。",
  "Long-term maintenance cost.": "长期维护成本。",
  "Agent is mapping knowledge impact…": "智能体正在分析知识影响…",
  "Re-run Maintainer-side Agent": "重新运行维护者侧智能体",
  "Ask Maintainer-side Agent": "询问维护者侧智能体",
  "The Agent produces an analysis. It cannot accept knowledge or approve a Contract.": "智能体只产生分析，不能接受知识或批准契约。",
  "Maintainer Claim Resolution": "维护者主张决议",
  "decisions drafted": "项决议已拟定",
  "Run the Maintainer-side Agent to prepare impact-aware suggestions.": "请运行维护者侧智能体，以生成考虑影响的建议。",
  "Maintainer decision": "维护者决策",
  "Project wording": "项目表述",
  "Accept": "接受",
  "Modify": "修改",
  "Narrow": "缩小范围",
  "Defer": "推迟",
  "Reject": "拒绝",
  "Request evidence": "请求证据",
  "Shape scope, rollout, proof, and rationale": "调整范围、发布策略、证明与理由",
  "Target scopes · comma separated": "目标范围 · 逗号分隔",
  "Rollout": "发布策略",
  "Not applicable": "不适用",
  "Experimental": "实验性",
  "Stable": "稳定",
  "Claim-linked proof": "主张关联证明",
  "Public default stays unchanged": "公共默认值保持不变",
  "Sources remain visible": "来源保持可见",
  "Scope stays within Research Brief": "范围保持在研究简报内",
  "Preference requires confirmation": "偏好必须经过确认",
  "Every conclusion retains evidence": "每项结论都保留证据",
  "Unknown Verifier IDs block Contract synthesis until removed.": "未知的验证器 ID 会阻止契约实现，必须先移除。",
  "Maintainer rationale": "维护者理由",
  "Rationale:": "理由：",
  "Targets:": "目标：",
  "Knowledge Impact Map": "知识影响图",
  "Impact is predicted, not proven": "影响是预测，不是证明",
  "Run the Maintainer-side Agent to map impact before code.": "请先运行维护者侧智能体分析影响，再查看代码。",
  "optional conclusion-first": "可选的结论优先",
  "Human decision": "人工决策",
  "Policy determined": "由策略决定",
  "evidence required": "需要证据",
  "Knowledge Integration Contract": "知识集成契约",
  "Derived from human decisions": "源自人工决策",
  "The Contract is not a sixth core object. It is the governed project-side resolution nested inside this KPR.": "契约不是第六个核心对象，而是嵌套在 KPR 中、受治理的项目侧决议。",
  "Approve decisions & generate Contract": "批准决议并生成契约",
  "Contract for": "契约对应",
  "Accepted knowledge": "接受的知识",
  "Rejected knowledge": "拒绝的知识",
  "not set": "未设置",
  "Project Policy baseline": "项目策略基线",
  "Implementation boundary": "实现边界",
  "Required proof": "必需证明",
  "Context boundary": "上下文边界",
  "Synthesis blocked": "实现已阻止",
  "Project Agent is rebuilding from the Contract…": "项目智能体正在依据契约重建…",
  "Start blind reconstruction": "启动基于契约的独立重构",
  "Behavior, Knowledge, and Evidence Diff": "行为、知识与证据差异",
  "Approve a Contract and ask the Project Agent to synthesize a candidate.": "请先批准契约，再让项目智能体生成候选实现。",
  "Behavior": "行为",
  "Before": "之前",
  "After": "之后",
  "Context first; one public behavior": "背景优先；一种公共行为",
  "Optional conclusion-first mode for Research Brief": "研究简报可选的结论优先模式",
  "Knowledge": "知识",
  "One local user preference": "一个本地用户偏好",
  "Narrow experimental capability; public default unchanged": "范围受限的实验能力；公共默认值不变",
  "4 local overlay verifiers": "4 个本地覆写层验证器",
  "5 project Contract verifiers": "5 个项目契约验证器",
  "Optional code-oriented representation": "可选的代码视图",
  "Run Contract verifiers": "运行契约验证器",
  "Rollback candidate": "回滚候选实现",
  "Maintainer adopts candidate": "维护者采纳候选实现",
  "Project policy": "项目策略",
  "Evidence posture": "证据立场",
  "Prototype evidence": "原型证据",
  "Shows a bounded system behavior. Does not prove lower Maintainer workload.": "展示有边界的系统行为，但不能证明维护者工作量更低。",
  "Authority": "权限归属",
  "Goal": "目标",
  "Human": "人类",
  "Knowledge decision": "知识决策",
  "Implementation": "实现",
  "Completion": "完成判断",
  "Verifier": "验证器",
  "Adoption": "采纳",
  "low": "低",
  "medium": "中",
  "high": "高",
  "available": "可用",
  "not configured": "未设置",
  "proposal": "方案",
  "proposed": "已提出",
  "pass": "通过",
  "fail": "失败",
  "verified": "已验证",
  "approved": "已批准",
  "blocked": "已阻止",
  "adopted": "已采纳",
  "completed": "已完成",
  "attested": "已签认",
  "missing": "缺失",
  "hidden": "隐藏",
  "replay": "回放",
  "scripted": "脚本",
  "live": "实时",
  "captured": "已捕获",
  "contributor review": "贡献者审查",
  "submitted": "已提交",
  "knowledge gate": "知识准入检查",
  "maintainer review": "维护者审查",
  "project agent synthesis": "项目智能体实现",
  "verification passed": "验证通过",
  "rolled back": "已回滚",
  "human statement": "人类陈述",
  "agent extraction": "智能体提取",
  "human attested": "已人工签认",
  "project reviewed": "项目已审查",
  "accepted for synthesis": "已接受实现",
  "waiting for human": "等待人工",
  "Create a reversible local preference overlay that changes presentation order without changing public project behavior.": "创建可回滚的本地偏好覆写层，只调整呈现顺序，不改变公共项目行为。",
  "Read the Agentic Software Contract and mutable surfaces.": "读取 Agentic Software 契约与可变界面。",
  "Propose a conclusion-first User Overlay.": "提出结论优先的用户覆写层方案。",
  "Preview the behavioral change before writing.": "写入前预览行为变化。",
  "Verify source preservation, public-core isolation, and rollback.": "验证来源保留、公共内核隔离与回滚能力。",
  "Show the conclusion before evidence while keeping sources visible.": "在证据之前显示结论，同时保持来源可见。",
  "Should this remain private or be proposed as an optional public capability after verification?": "这项能力应保留为私有修改，还是在验证后作为可选公共能力提出？",
  "The need is credible, but the evidence supports an opt-in Research Brief capability rather than a new public default.": "该需求可信，但现有证据只支持研究简报中的可选能力，不支持新的公共默认行为。",
  "Separate explicit user knowledge from project-side inference.": "区分用户明确表达的知识与项目侧推断。",
  "Map behavioral, provenance, compatibility, verification, and rollout impact.": "分析行为、溯源、兼容性、验证与发布影响。",
  "Narrow the public scope and preserve project invariants.": "收窄公共范围，并保持项目不变量。",
  "Draft a contract for Maintainer approval.": "起草契约，交由维护者批准。",
  "Do we require evidence from a second document type before stable rollout?": "稳定发布前是否需要第二种文档类型的证据？",
  "Implement the approved contract as an experimental opt-in capability without reading the contributor patch.": "在不读取贡献者补丁的前提下，将已批准契约实现为实验性的可选能力。",
  "Read the Maintainer-approved Integration Contract.": "读取维护者批准的知识集成契约。",
  "Create a checkpoint in the Project Candidate workspace.": "在项目候选工作区创建检查点。",
  "Implement the narrow optional capability.": "实现范围受限的可选能力。",
  "Run all contract verifiers and report any mismatch.": "运行全部契约验证器，并报告任何不一致。",
  "User-side Agent started": "用户侧 Agent 已启动",
  "Recorded reference run; no live provider request is occurring.": "正在使用录制的参考运行，不会发起实时 Provider 请求。",
  "Agentic Software context": "Agentic Software 上下文",
  "Manifest, Policy, Research Brief, mutable surfaces, and the user request were assembled.": "已组装 Manifest、Project Policy、研究简报、可变界面与用户需求。",
  "Write boundary checked": "写入边界已检查",
  "User-side Agent may propose only a reversible User Realization overlay.": "用户侧 Agent 只能提出可回滚的用户本地实现覆写层。",
  "Plan proposed": "计划已提出",
  "Read → propose → preview → verify; public project state remains out of scope.": "读取 → 提案 → 预览 → 验证；公共项目状态始终不在权限范围内。",
  "Proposed a structured conclusion-first overlay.": "已提出结构化的结论优先覆写层。",
  "Overlay preview ready": "覆写层预览已就绪",
  "The proposal preserves sources, light theme, and a reset path.": "方案保留来源、浅色主题与重置路径。",
  "Rollback point recorded": "回滚点已记录",
  "Reference workspace captured before the overlay is applied.": "在应用覆写层前，已保存参考工作区状态。",
  "Proposal ready for human review": "方案已可供人工审查",
  "No change was applied automatically.": "没有自动应用任何修改。",
  "Maintainer-side Agent started": "维护者侧 Agent 已启动",
  "Knowledge review mode; this Agent has no code-write authority.": "当前为知识审查模式；该 Agent 没有代码写入权限。",
  "KPR review context": "KPR 审查上下文",
  "Human-attested claims, evidence, Project Policy, and contribution boundary were assembled.": "已组装经人工签认的知识主张、证据、Project Policy 与贡献边界。",
  "Mapped six impact dimensions before code synthesis.": "代码实现前已分析六个影响维度。",
  "Default stability conflict": "默认行为稳定性冲突",
  "The user preference cannot become a public default without Maintainer shaping.": "未经维护者调整，用户偏好不能成为公共默认行为。",
  "Proposed narrowing the capability to an experimental opt-in Research Brief setting.": "建议将能力收窄为研究简报中的实验性可选设置。",
  "Evidence gaps remain visible": "证据缺口保持可见",
  "Other document types remain unknown; no unsupported generalization was accepted.": "其他文档类型仍属未知；未接受缺乏证据的泛化。",
  "Review brief ready": "审查简报已就绪",
  "Suggestions are drafts until the Maintainer records decisions.": "在维护者记录决策前，所有建议都只是草稿。",
  "Project Agent started": "项目 Agent 已启动",
  "Blind Reconstruction mode is active.": "已启用基于契约的独立重构模式。",
  "Contract-only implementation context": "仅包含契约的实现上下文",
  "Project Policy, approved Contract, reference code model, and verifiers were assembled; contributor patch was excluded.": "已组装 Project Policy、已批准契约、参考代码模型与验证器；贡献者补丁被排除。",
  "Implementation boundary checked": "实现边界已检查",
  "Only the experimental Research Brief capability may be changed.": "只能修改实验性的研究简报能力。",
  "Project checkpoint created": "项目检查点已创建",
  "The candidate workspace can be rolled back independently.": "候选工作区可以独立回滚。",
  "Generated a structured project candidate from the Contract.": "已依据契约生成结构化项目候选实现。",
  "Requested all five Contract verifiers.": "已请求运行全部五个契约验证器。",
  "Candidate ready for verification": "候选实现已可验证",
  "Generation is not treated as completion.": "生成结果不视为完成。",
  "Candidate returned to Maintainer": "候选实现已交回维护者",
  "No public merge or adoption occurred automatically.": "没有自动执行公共合并或采纳。",
  "Required structured proposal produced; no public state changed.": "已生成必需的结构化方案；公共状态没有变化。",
  "run started": "运行已启动",
  "context assembled": "上下文已组装",
  "plan proposed": "计划已提出",
  "assistant message": "Agent 消息",
  "tool call": "工具调用",
  "policy check": "策略检查",
  "approval requested": "请求审批",
  "approval recorded": "审批已记录",
  "tool result": "工具结果",
  "verifier result": "验证器结果",
  "checkpoint created": "检查点已创建",
  "rollback": "回滚",
  "usage": "用量",
  "refusal": "拒绝执行",
  "provider error": "Provider 错误",
  "run completed": "运行已完成",
  "run stopped": "运行已停止",
  "Conclusion appears before evidence": "结论显示在证据之前",
  "Rendered section order begins with the conclusion and keeps evidence after it.": "渲染后的章节顺序以结论开始，并在其后保留证据。",
  "The requested conclusion-first order is not active.": "请求的结论优先顺序尚未启用。",
  "Sources are preserved": "来源得到保留",
  "All reference sources remain attached.": "所有参考来源仍保持关联。",
  "One or more reference sources would be hidden or removed.": "一个或多个参考来源将被隐藏或移除。",
  "Public core remains unchanged": "公共内核保持不变",
  "The proposed change is isolated to the User Realization layer.": "建议修改被隔离在用户本地实现层。",
  "Overlay is reversible": "覆写层可回滚",
  "A checkpoint exists and removing the overlay restores the reference behavior.": "检查点已经存在；移除覆写层即可恢复参考实现行为。",
  "This bounded Verifier does not establish general user benefit, production safety, or lower Maintainer workload.": "这个有边界的验证器不能证明普遍用户收益、生产环境安全性或维护者工作量下降。",
  "Reference-application evidence; eligible for public export only after the KPR privacy scan passes.": "参考应用证据；只有通过 KPR 隐私扫描后才可公开导出。",
  "The capability is opt-in.": "该能力需要用户主动启用。",
  "Public default remains unchanged": "公共默认行为保持不变",
  "The candidate changes the public default.": "候选实现改变了公共默认行为。",
  "Sources remain visible in the candidate behavior.": "候选行为中的来源保持可见。",
  "The candidate may hide sources.": "候选实现可能隐藏来源。",
  "Scope is narrow": "范围受限",
  "The feature applies only to Research Brief documents.": "该功能仅适用于研究简报文档。",
  "The feature scope is broader than approved.": "功能范围超出已批准边界。",
  "Preference is saved only after user confirmation.": "只有用户确认后才保存偏好。",
  "Preference may be persisted silently.": "偏好可能被静默持久化。",
  "Unsupported conclusion guard": "缺乏证据的结论防护",
  "Every conclusion block must retain at least one linked evidence item.": "每个结论块必须保留至少一项关联证据。",
  "Required Verifier is unavailable": "必需验证器不可用",
  "Missing Human Attestation": "缺少人工签认",
  "Knowledge Gate blocks Agent-extracted claims.": "知识准入检查会阻止未经人工签认的 Agent 提取主张。",
  "Human attestation was missing and Agent-extracted Claims remained unattested.": "缺少人工签认，Agent 提取的知识主张仍处于未签认状态。",
  "Privacy and secret block": "隐私与密钥阻断",
  "Submission is blocked before project review.": "提交在进入项目审查前即被阻止。",
  "Policy conflict and verifier failure": "策略冲突与验证失败",
  "Unsafe public default cannot be completed.": "不安全的公共默认行为不能被标记为完成。",
  "Agent says done, verifier says no": "Agent 声称完成，但验证器判定未完成",
  "Natural language completion has no authority.": "自然语言中的完成声明没有判定权限。",
  "Candidate status remains failed until every required verifier passes.": "在所有必需验证器通过前，候选状态保持失败。",
  "Sensitive information was detected and the submission remained blocked.": "检测到敏感信息，提交因此继续保持阻断状态。",
  "Unsafe defaults, broad scope, hidden sources, missing confirmation, and unsupported conclusions failed verification.": "不安全的默认行为、越界范围、隐藏来源、缺少确认以及无证据结论均未通过验证。",
  "problem": "问题",
  "intent": "意图",
  "expected behavior": "预期行为",
  "constraint": "约束",
  "acceptance criterion": "验收标准",
  "invariant": "不变量",
  "decision": "决策",
  "evidence interpretation": "证据解读",
  "counterexample": "反例",
  "open question": "开放问题",
  "research-brief": "研究简报",
  "summary-layout": "摘要布局",
  "sources": "来源",
  "user-preference": "用户偏好",
  "user-realization": "用户本地实现",
  "contribution": "知识贡献",
  "public-core": "公共内核",
  "public-product": "公共产品",
  "experimental-settings": "实验性设置",
  "explicit": "明确提出",
  "agent-inferred": "Agent 推断",
  "policy-required": "策略要求",
  "unknown": "未知",
  "accept": "接受",
  "modify": "修改",
  "narrow": "缩小范围",
  "defer": "推迟",
  "reject": "拒绝",
  "request evidence": "请求证据",
  "Research Brief documents only": "仅限研究简报文档",
  "Opt-in setting; public default unchanged": "选择性启用；公共默认行为保持不变",
  "Preference saved only after confirmation": "仅在明确确认后保存偏好",
  "Contributor patch remains hidden from Project Agent": "贡献者补丁对项目 Agent 保持隐藏",
  "Prototype workspaces": "原型工作区",
  "Principle lenses": "设计原则索引",
  "Runtime planes": "运行时平面",
  "AgenticXYZ Guide Agent": "AgenticXYZ 引导 Agent",
  "AgenticXYZ Global Guide": "AgenticXYZ 全局助手",
  "Global scope · all applications and the workbench": "全局作用域 · 所有应用与整个工作台",
  "The software itself is the Agent target": "软件本身就是 Agent 的作用对象",
  "Open AgenticXYZ Guide Agent": "打开 AgenticXYZ 引导 Agent",
  "Close Guide Agent": "关闭引导 Agent",
  "I am the AgenticXYZ Guide. This software is also an Agent target: I can configure its Provider, explain its knowledge model, and guide you without taking human decisions.": "我是 AgenticXYZ 引导 Agent。这个软件本身也是 Agent 的作用对象：我可以帮助配置 Provider、解释知识模型并引导操作，但不会替人作出决定。",
  "I am the AgenticXYZ Guide. This software is also an Agent target: I can explain its knowledge model and guide the static Replay without taking human decisions.": "我是 AgenticXYZ 引导 Agent。这个软件本身也是 Agent 的作用对象：我可以解释它的知识模型并引导静态回放，但不会替人作出决定。",
  "Provider ready": "Provider 已就绪",
  "Provider not configured": "Provider 尚未配置",
  "Set up Provider": "配置 Provider",
  "Static Replay": "静态回放",
  "GitHub Pages · no Provider or API key calls": "GitHub Pages · 不调用 Provider，也不接收 API 密钥",
  "View": "视图",
  "Application only": "仅参考应用",
  "Full workbench": "完整工作台",
  "Return to full workbench": "返回完整工作台",
  "Show only the reference application": "仅显示参考应用",
  "Current guided step": "当前引导步骤",
  "Show me where": "带我前往",
  "Show next step": "显示下一步",
  "Open settings": "打开设置",
  "Open Runtime": "打开运行时",
  "Open workspace": "打开工作区",
  "Guide Agent is thinking…": "引导 Agent 正在思考…",
  "Suggested questions": "建议问题",
  "What is a KPR?": "什么是 KPR？",
  "Why Agent First?": "为什么强调 Agent First？",
  "Why is this Agent First?": "为什么这体现了 Agent First？",
  "Ask about this software or its workflow…": "询问这个软件、概念或操作流程…",
  "Ask the Guide Agent": "向引导 Agent 提问",
  "Send question": "发送问题",
  "You": "你",
  "Live Provider answer": "实时 Provider 回答",
  "Local guide answer": "本地引导答案",
  "Guide boundary: it may explain and navigate, but never approve, attest, merge, or adopt for a person.": "引导边界：它可以解释与导航，但绝不会代替人批准、签认、合并或采纳。",
  "The Live Guide answer was unavailable, so I used the local guide.": "实时引导回答暂不可用，已改用本地引导。",
  "Open Model API Settings to choose one Provider and model, enter an API key, and verify the connection. The key stays in local Gateway memory and is not written to browser storage or project files.": "打开“模型 API 设置”，选择一个 Provider 与模型，填入 API 密钥并验证连接。密钥只保留在本地 Gateway 内存中，不会写入浏览器存储或项目文件。",
  "This GitHub Pages build runs static Replay only. It does not accept API keys or call a Provider. Clone the project and use the local Gateway for Provider-backed runs.": "这个 GitHub Pages 版本只运行静态回放，不接收 API 密钥，也不调用 Provider。需要接入真实 Provider 时，请克隆项目并使用本地 Gateway。",
  "A KPR is a governed knowledge package: human need, Agent-extracted Claims, evidence, provenance, constraints, unknowns, and human attestation. The contributor's local code is evidence, not implementation authority.": "KPR 是受治理的知识包，包含人的需求、Agent 提取的知识主张、证据、溯源、约束、未知项与人工签认。贡献者的本地代码属于证据，并不代表实现权限。",
  "The Agentic Runtime makes probabilistic work inspectable through scoped context, policy checks, structured proposals, human gates, verifier evidence, checkpoints, and rollback.": "Agentic Runtime 通过限定上下文、策略检查、结构化方案、人工审批点、验证器证据、检查点与回滚，让概率性智能的工作过程可检查。",
  "Agent First is an architecture principle, not a transfer of authority. The software exposes Agent-readable capabilities and state, while people retain goals, judgment, responsibility, approval, and final governance.": "Agent First 是架构原则，并不意味着转移权力。软件向 Agent 暴露可读的能力与状态，而目标、判断、责任、批准与最终治理仍然属于人。",
  "I can take you to the current guided step and point out the next human decision without clicking approval on your behalf.": "我可以带你前往当前步骤，并指出下一项需要人判断的事项，但不会替你点击批准。",
  "I can explain Agentic Software, KPR, Runtime reliability, and human governance; configure the active Provider; or guide you to the next step. In Live Agent mode, I can use the configured Provider for a contextual answer.": "我可以解释 Agentic Software、KPR、Runtime 可靠性与人类治理，帮助配置当前 Provider，或引导你完成下一步。在实时 Agent 模式下，我还可以使用已配置的 Provider 结合当前上下文回答。",
  "I can explain Agentic Software, KPR, Runtime reliability, and human governance, or guide you through the recorded workflow. This GitHub Pages build does not call a Provider.": "我可以解释 Agentic Software、KPR、Runtime 可靠性与人类治理，或引导你完成录制工作流。这个 GitHub Pages 版本不会调用 Provider。",
  "Describe how the reference software should work differently for you, then ask the User-side Agent for a bounded proposal.": "描述你希望参考软件如何改变，然后让用户侧 Agent 生成一个边界明确的方案。",
  "Inspect and approve the User Overlay": "审查并批准用户覆写层",
  "Review the proposed scope, source guarantees, and rollback boundary. Only you can approve the local change.": "审查方案范围、来源保留保证与回滚边界。只有你能批准这项本地修改。",
  "Run independent local verifiers": "运行独立的本地验证器",
  "The Agent proposal is not completion. Verify behavior, sources, isolation, and rollback before creating contribution knowledge.": "Agent 给出方案并不等于完成。形成贡献知识前，先验证行为、来源、隔离边界与回滚能力。",
  "Package the verified need, intent, evidence, limits, and provenance as knowledge for project review.": "将已验证的需求、意图、证据、边界与溯源整理成知识，交由项目审查。",
  "Review and attest the KPR knowledge": "审阅并签认 KPR 知识",
  "Review the Agent-extracted Claims, optionally correct wording, record human attestation, scan the package, and submit it to the Knowledge Gate.": "审阅 Agent 提取的知识主张，按需修正表述，完成人工签认、知识包扫描，并提交知识准入检查。",
  "Map knowledge impact": "分析知识影响",
  "Use the Maintainer-side Agent to separate known, inferred, and unknown effects. It may advise, but it cannot decide.": "使用维护者侧 Agent 区分已知、推断与未知影响。它可以提供建议，但不能作出决定。",
  "Approve the Knowledge Integration Contract": "批准知识集成契约",
  "Shape Claim decisions, implementation boundaries, rollout, and required proof before the Project Agent can act.": "在项目 Agent 行动前，确定知识主张决策、实现边界、发布策略与所需证据。",
  "Synthesize a project-owned candidate": "生成项目自主实现的候选版本",
  "The Project Agent implements only the approved Contract, without reading or merging the contributor patch.": "项目 Agent 只依据已批准的契约实现，不读取也不合并贡献者补丁。",
  "Verify before adoption": "采纳前验证",
  "Run every Contract verifier. Final adoption remains a Maintainer decision after the evidence passes.": "运行契约要求的全部验证器。证据通过后，最终采纳仍由维护者决定。",
  "Human-governed adoption is complete": "由人治理的采纳流程已完成",
  "Inspect the KPR, Contract, Runtime trace, verifier evidence, and final human decision as one auditable chain.": "将 KPR、契约、Runtime 轨迹、验证器证据与最终人工决策作为一条可审计链路进行检查。",
  "Independent proof has passed. A Maintainer must still make the final adoption decision.": "独立验证已经通过，但最终采纳仍必须由维护者作出决定。",
  "Application workflow controls": "参考应用流程控制",
  "Application workflow": "参考应用流程",
  "Operate the same governed state from the XYZ Agent": "通过 XYZ 助手操作同一套受治理状态",
  "Your local need": "你的本地需求",
  "Correct one Agent-extracted Claim in your own words": "用你自己的表述修正一条由 Agent 提取的知识主张",
  "Save contributor correction": "保存贡献者修正",
  "The XYZ Agent exposes the action here, but every human gate still requires your click.": "XYZ 助手会在这里提供操作入口，但每一个人工关卡仍需由你亲自点击。",
  "Reference application gallery": "参考应用库",
  "Preset workflow": "预设流程",
  "Preset active": "预设已启用",
  "Custom request preserved": "已保留自定义需求",
  "Load this preset": "载入此预设",
  "Use this preset with the XYZ Agent": "在 XYZ 助手对话中使用此预设",
  "Load and use this preset with the XYZ Agent": "载入预设并交给 XYZ 助手",
  "This request still matches a system preset and may follow the selected application automatically.": "当前需求仍与系统预设一致，切换参考应用时可以自动跟随对应预设。",
  "Your edited request was not overwritten when the application changed.": "切换应用时没有覆盖你已经编辑过的需求。",
  "Start with this application's XYZ Agent": "交给本应用的 XYZ 助手",
  "Ask the XYZ Agent about this change": "请 XYZ 助手分析这项修改",
  "XYZ Agent application conversation": "XYZ 助手应用对话",
  "Same governed capability as the Local XYZ Agent": "与局部 XYZ 助手共用受治理能力",
  "in scope": "作用域内",
  "Change already applied": "修改已应用",
  "Send a request here or in the Local XYZ Agent. Both operate the same application capabilities and governed state.": "你可以在这里或局部 XYZ 助手中发起请求；两个入口操作的是同一组应用能力与受治理状态。",
  "Application-local progress": "应用内流程进度",
  "Start the request with the Local XYZ Agent. It will propose the preset capability before any change is applied.": "将需求交给局部 XYZ 助手；在应用任何修改前，它会先提出预设能力方案。",
  "Send the request here or from the Local XYZ Agent. The XYZ Agent will propose an allowlisted capability before any change is applied.": "可以在这里或局部 XYZ 助手中发起请求。XYZ 助手会先提出白名单内的能力方案，再由你确认是否应用修改。",
  "Conclusion-first Research Brief": "结论优先的研究简报",
  "Interactive sidebar for Agent Demo": "Agent Demo 交互式侧边栏",
  "Structured headlines for Daily News": "每日新闻结构化标题",
  "Ask the User-side Agent for a bounded overlay.": "请用户侧 Agent 提出边界明确的覆写层方案。",
  "Review and approve the reversible local realization.": "审查并批准可回滚的本地实现。",
  "Verify source preservation, isolation, and rollback.": "验证来源保留、隔离边界与回滚能力。",
  "Structure the verified knowledge as a KPR.": "将验证后的知识结构化为 KPR。",
  "Ask the application-scoped XYZ Agent for the sidebar capability.": "请应用作用域内的 XYZ 助手提出侧边栏能力方案。",
  "Review and apply the user-local change.": "审查并应用用户本地修改。",
  "Verify that the sidebar is usable and the conversation remains visible.": "验证侧边栏可以使用，并且中央对话仍然可见。",
  "Form a bounded KPR draft, or roll back to the checkpoint.": "形成边界明确的 KPR 草稿，或回滚到检查点。",
  "Ask the application-scoped XYZ Agent for structured headline reconstruction.": "请应用作用域内的 XYZ 助手提出结构化标题重构方案。",
  "Verify title consistency and metadata preservation.": "验证标题结构一致性与元数据保留情况。",
  "Form a bounded KPR draft, or roll back to the original headlines.": "形成边界明确的 KPR 草稿，或回滚到原始标题。",
  "Add an interactive right sidebar to Agent Demo while preserving the central conversation and keeping the change user-local and reversible.": "为 Agent Demo 添加交互式右侧栏，同时保留中央对话，并确保修改仅作用于用户本地且可以回滚。",
  "Reconstruct the Daily News headlines by actor, action, object, and consequence while preserving scores, authors, sources, timestamps, and rollback.": "按照主体、行动、对象与结果重构每日新闻标题，同时保留评分、作者、来源、时间戳与回滚能力。",
  "Use this application's Local XYZ Agent for bounded capabilities, checkpoints, verification, KPR structuring, and rollback. Use the Global XYZ Agent only when you need to control another application or the outer workbench.": "使用本应用内的局部 XYZ 助手完成有边界的能力调用、检查点、验证、KPR 结构化与回滚；只有需要控制其他应用或外部工作台时，才使用全局 XYZ 助手。",
  "Open this application's XYZ Agent": "打开本应用的 XYZ 助手",
  "Local XYZ Agent": "局部 XYZ 助手",
  "Application scope": "应用作用域",
  "Only this application": "仅限当前应用",
  "Global controls are intentionally unavailable here.": "这里有意不提供全局控制能力。",
  "Close Local XYZ Agent": "关闭局部 XYZ 助手",
  "Open Local XYZ Agent for": "打开局部 XYZ 助手：",
  "local": "局部",
  "Capabilities in this application": "当前应用内能力",
  "Send to conversation": "发送到下方对话",
  "Form this application's KPR": "形成本应用的 KPR",
  "Stopped at the human-review boundary": "已停在人工审阅边界",
  "What can you do here?": "你在这里能做什么？",
  "Add a sidebar": "添加侧边栏",
  "Reconstruct the headlines": "重构新闻标题",
  "Ask the XYZ Agent about this application…": "询问 XYZ 助手关于当前应用的问题…",
  "Ask the Local XYZ Agent": "向局部 XYZ 助手提问",
  "This XYZ Agent cannot control another application or the outer workbench.": "这个 XYZ 助手不能控制其他应用或外部工作台。",
  "Reset icon position": "恢复图标默认位置",
  "Drag within this application, or use the arrow keys to move. Press Home to restore the default position.": "可以在当前应用内拖动，也可以使用方向键移动；按 Home 键恢复默认位置。",
  "Drag to reposition the Local XYZ Agent": "拖动以调整局部 XYZ 助手的位置",
  "I can help with this application only. I cannot switch applications, configure the Provider, open the global Runtime, or make project decisions.": "我只帮助你操作当前应用，不能切换应用、配置 Provider、打开全局 Runtime，也不能作出项目决策。",
  "That request is outside this application's scope. Use the Global XYZ Agent to switch applications or control workbench-level settings.": "该请求超出当前应用的作用域。请使用全局 XYZ 助手切换应用或控制工作台级设置。",
  "I can help describe a need, request a bounded proposal, checkpoint and verify the local realization, then form this application's KPR.": "我可以帮助描述需求、请求边界明确的方案、为本地实现建立检查点并完成验证，然后形成本应用的 KPR。",
  "Within Issue Triage I may explain priority, grouping, and evidence-request surfaces. Closing, assigning, or accepting an Issue remains human-only.": "在 Issue 分诊台中，我可以解释优先级、分组与证据请求界面；关闭、指派或接受 Issue 仍只能由人决定。",
  "Within Release Desk I may explain the Contract, verifier output, release notes, risk summary, and rollback plan. Approval and publishing remain human-only.": "在发布决策台中，我可以解释契约、验证器输出、发布说明、风险摘要和回滚方案；批准与发布仍只能由人决定。",
  "I can apply an allowlisted user-local change, record a checkpoint, verify it, form a bounded KPR draft, and roll it back.": "我可以应用白名单内的用户本地修改、记录检查点、完成验证、形成有边界的 KPR 草稿，并随时回滚。",
  "I found an allowlisted, reversible capability in this application.": "我在当前应用中找到了一个白名单内、可回滚的能力。",
  "The reversible user-local change is applied and checkpointed. Verify it before asking me to form a KPR draft.": "可回滚的用户本地修改已经应用并建立检查点；请先验证，再让我形成 KPR 草稿。",
  "Describe a need inside this application": "描述当前应用内的需求",
  "Ask this application's Agent": "询问本应用的 Agent",
  "The proposal is ready. Inspect it, then explicitly approve this reversible local realization.": "方案已经就绪。请先检查，再显式批准这个可回滚的本地实现。",
  "The local realization is applied and checkpointed. Verification must pass before contribution knowledge is created.": "本地实现已经应用并建立检查点；形成贡献知识前必须通过验证。",
  "The application change is verified. The XYZ Agent can now structure the need, evidence, and boundaries as a KPR draft.": "应用修改已经验证。XYZ 助手现在可以把需求、证据与边界结构化为 KPR 草稿。",
  "This application's KPR exists. Human review and project governance continue in the KPR Bridge.": "本应用的 KPR 已经形成；人工审阅与项目治理将在 KPR 知识协作界面继续。",
  "Continue to this KPR": "继续处理本应用的 KPR",
  "Choose a reference application": "选择参考应用",
  "Full KPR scenario": "完整 KPR 流程",
  "Agent-targetable preview": "Agent 可作用的预览",
  "illustrative preview": "示意预览",
  "Running reference application": "正在运行的参考应用",
  "Brief Studio": "简报工作台",
  "Research Brief navigation": "研究简报导航",
  "Current brief": "当前简报",
  "Source library": "来源库",
  "Presentation settings": "呈现设置",
  "Knowledge document": "知识文档",
  "User Overlay active": "用户覆写层已启用",
  "Reference layout": "参考布局",
  "Inspectable reference surface": "可检查的参考应用界面",
  "This app shows another Agent-targetable software surface. Prototype 1 keeps the complete governed KPR path scoped to Research Brief so the evidence boundary stays honest.": "这个应用展示了另一种可由 Agent 作用的软件界面。Prototype 1 将完整、受治理的 KPR 流程限定在研究简报中，以如实保持证据边界。",
  "Return to full KPR scenario": "返回完整 KPR 流程",
  "Issue Triage": "Issue 分诊台",
  "Triage queue": "分诊队列",
  "Needs review": "待审查",
  "Needs evidence": "待补充证据",
  "Ready for decision": "可进入决策",
  "Reference application 02": "参考应用 02",
  "Sort by policy risk": "按策略风险排序",
  "Source links disappear in compact view": "紧凑视图中来源链接消失",
  "Remember my preferred summary order": "记住我偏好的摘要顺序",
  "Clarify what the Knowledge Gate checks": "说明知识准入检查的具体内容",
  "P0 · evidence invariant": "P0 · 证据不变量",
  "P1 · user-local preference": "P1 · 用户本地偏好",
  "P2 · documentation": "P2 · 文档",
  "Agent-targetable surfaces": "Agent 可作用界面",
  "priority · grouping · evidence request": "优先级 · 分组 · 证据请求",
  "Project Policy": "项目策略",
  "Evidence before prioritization": "证据先于优先级判断",
  "The Agent may organize the queue and surface missing knowledge. It cannot close, assign, or accept an issue.": "Agent 可以整理队列并指出缺失知识，但不能关闭、指派或接受 Issue。",
  "Human decision required": "需要人工决策",
  "Release Desk": "发布决策台",
  "Candidate release": "候选版本",
  "A compact operational surface for evidence-gated release decisions.": "一个以证据准入为前提、用于发布决策的紧凑操作界面。",
  "checks ready": "项检查已就绪",
  "Release evidence": "发布证据",
  "Live status": "实时状态",
  "Behavior contract": "行为契约",
  "Source invariant": "来源不变量",
  "Rollback path": "回滚路径",
  "Maintainer adoption": "维护者采纳",
  "passed": "已通过",
  "waiting": "等待中",
  "Agent target map": "Agent 作用对象图",
  "Readable": "可读取",
  "Contract, verifier output, release policy": "契约、验证器输出、发布策略",
  "Proposable": "可提出方案",
  "Release notes, risk summary, rollback plan": "发布说明、风险摘要、回滚计划",
  "Human only": "仅限人",
  "Approve and publish": "批准并发布",
  "Agent Demo": "Agent Demo",
  "Daily News & Notes": "每日新闻与笔记",
  "Interactive user-side sandbox": "可交互的用户侧沙盒",
  "Agent-readable software": "Agent 可读软件",
  "Reference application 04": "参考应用 04",
  "No local change": "没有本地修改",
  "KPR draft ready": "KPR 草稿已就绪",
  "clean": "未修改",
  "reference": "参考状态",
  "applied": "已应用",
  "rolled_back": "已回滚",
  "Add an interactive right sidebar": "增加可交互的右侧边栏",
  "Adds a user-local terminal sidebar while preserving the central conversation and public reference behavior.": "增加用户本地的终端侧边栏，同时保留中央对话区和公共参考行为。",
  "Apply 16px and blue theme": "应用 16px 字号与蓝色主题",
  "Applies the user's local 16px typography and blue visual preference without changing the project default.": "应用用户本地的 16px 字号与蓝色视觉偏好，但不改变项目默认值。",
  "Reuse the Daily News clock": "复用每日新闻的时钟",
  "Adds a small clock learned from the Daily News reference surface to the Agent Demo user realization.": "把从每日新闻参考界面中学到的小型时钟加入 Agent Demo 的用户本地实现。",
  "Apply my cross-application preferences": "应用我的跨应用偏好",
  "Applies the same user-local 16px and blue presentation preference to Daily News & Notes.": "把同一套用户本地的 16px 字号与蓝色呈现偏好应用到每日新闻与笔记。",
  "Reconstruct headlines by news elements": "按新闻要素重构标题",
  "Rewrites visible headlines into actor, action, object, and consequence structure while retaining the original item metadata.": "把可见标题重构为主体、动作、对象与结果的结构，同时保留原始条目元数据。",
  "User-side application controls": "用户侧应用控制",
  "User-side capabilities": "用户侧能力",
  "Operate Agent Demo": "操作 Agent Demo",
  "Operate Daily News & Notes": "操作每日新闻与笔记",
  "Latest checkpoint": "最近检查点",
  "Verify local change": "验证本地修改",
  "Ask the XYZ Agent to form a KPR draft": "让 XYZ 助手形成 KPR 草稿",
  "Point to changed surface": "指出修改后的界面",
  "Roll back last change": "回滚上一项修改",
  "Restore reference defaults": "恢复参考默认值",
  "KPR draft · Agent structured": "KPR 草稿 · Agent 结构化整理",
  "evidence statements": "条证据陈述",
  "acceptance criteria": "项验收标准",
  "Human review is still required": "仍然需要人工审查",
  "Application action → checkpoint → verification → KPR. Local code never becomes project authority.": "应用操作 → 检查点 → 验证 → KPR。本地代码始终不会成为项目实现权威。",
  "Apply reversible change": "应用可回滚修改",
  "Ask the XYZ Agent to operate bounded application capabilities. Each change gets a checkpoint, verification boundary, and rollback path before the XYZ Agent can structure it as a KPR draft.": "让 XYZ 助手调用有边界的应用能力。每项修改都会先获得检查点、验证边界与回滚路径，之后 XYZ 助手才能把它结构化为 KPR 草稿。",
  "Open XYZ Agent controls": "打开 XYZ 助手控制面板",
  "Agentic Assistant": "Agentic 助手",
  "User-local realization": "用户本地实现",
  "What can I help you build?": "我可以帮你构建什么？",
  "This minimal software exposes its capabilities, mutable surfaces, checkpoints, and evidence boundary to the XYZ Agent.": "这个最小软件向 XYZ 助手暴露能力、可变界面、检查点与证据边界。",
  "Can you help this software fit the way I work?": "你能让这个软件更符合我的工作方式吗？",
  "Yes. I can invoke bounded user-side capabilities, and every local change remains inspectable and reversible.": "可以。我能调用有边界的用户侧能力，而且每项本地修改都可检查、可回滚。",
  "Message Agentic Assistant…": "给 Agentic 助手发送消息…",
  "Interactive terminal sidebar": "可交互终端侧边栏",
  "user-local": "用户本地",
  "Try help or status": "试试 help 或 status",
  "Terminal command": "终端命令",
  "Daily News": "每日新闻",
  "Today in Agentic Software": "今日 Agentic Software",
  "News-element titles": "新闻要素化标题",
  "Original titles": "原始标题",
  "Open-source agents move from chat to governed software actions": "开源 Agent 正从对话走向受治理的软件操作",
  "Agent projects expose governed software actions beyond chat": "Agent 项目开放超越对话的受治理软件操作",
  "Developers debate how user preferences should travel across apps": "开发者讨论用户偏好应如何跨应用流动",
  "Developers evaluate portable user preferences across applications": "开发者评估可跨应用迁移的用户偏好",
  "Evidence-first releases gain traction in AI tooling": "证据优先的发布方式正在 AI 工具中兴起",
  "AI tool maintainers adopt evidence-first release gates": "AI 工具维护者采用证据优先的发布关卡",
  "New interface patterns keep humans in control": "新的界面模式让人始终保有控制权",
  "Product teams design Agent interfaces with explicit human control": "产品团队以明确的人类控制设计 Agent 界面",
  "points": "分",
  "by project-maintainer": "作者 project-maintainer",
  "hours ago": "小时前",
  "Quick notes": "快速笔记",
  "Compare capability boundaries before treating a local preference as project knowledge.": "把本地偏好视为项目知识之前，先比较能力边界。",
  "Add note": "添加笔记",
  "XYZ Agent · bounded local capability": "XYZ Agent · 有边界的本地能力",
  "XYZ Agent · Recorded Replay": "XYZ Agent · 录制回放",
  "XYZ Agent · Scripted Fallback": "XYZ Agent · 脚本回退",
  "That user-local change is already active.": "该用户本地修改已经启用。",
  "The XYZ Agent applied a reversible user-local application change and recorded a checkpoint.": "XYZ 助手已应用可回滚的用户本地应用修改，并记录了检查点。",
  "The user-local application change passed its bounded verifiers.": "用户本地应用修改已通过有边界的验证。",
  "The last user-local application change was rolled back to its checkpoint.": "上一项用户本地应用修改已回滚到对应检查点。",
  "The reference application realization was restored to its defaults.": "参考应用的用户实现已恢复为默认状态。",
  "Verify the user-local application change before asking the XYZ Agent to structure a KPR draft.": "让 XYZ 助手结构化 KPR 草稿之前，请先验证用户本地应用修改。",
  "The XYZ Agent structured the verified local change as a bounded KPR draft. Human review is still required.": "XYZ 助手已把通过验证的本地修改结构化为有边界的 KPR 草稿，仍然需要人工审查。",
  "XYZ Agent KPR structuring started": "XYZ 助手开始结构化 KPR",
  "A human requested a KPR draft from one verified user-local application change.": "人请求把一项经过验证的用户本地应用修改整理为 KPR 草稿。",
  "Verified local context assembled": "已组装通过验证的本地上下文",
  "The verified change, its checkpoint, and bounded evidence statements were included.": "已纳入通过验证的修改、对应检查点与有边界的证据陈述。",
  "Contribution boundary enforced": "已执行贡献边界",
  "The local implementation remains evidence only; no project code, merge, or adoption authority was granted.": "本地实现只作为证据；未授予项目代码、合并或采纳权限。",
  "Structured KPR knowledge package": "已结构化 KPR 知识包",
  "Created a KPR draft from the allowlisted user-side capability and verified checkpoint.": "已根据白名单中的用户侧能力与通过验证的检查点创建 KPR 草稿。",
  "KPR source boundary passed": "KPR 来源边界检查通过",
  "The draft contains the problem, expected behavior, acceptance criteria, evidence, provenance, and explicit limitations.": "草稿包含问题、期望行为、验收标准、证据、来源追踪与明确局限。",
  "KPR draft linked to rollback state": "KPR 草稿已关联回滚状态",
  "The draft is linked to the source checkpoint; rolling back the source change invalidates this draft.": "草稿已关联来源检查点；回滚来源修改会使该草稿失效。",
  "Stopped at human review boundary": "已停在人工审查边界",
  "The XYZ Agent completed knowledge structuring. Human review remains required before any contribution or project decision.": "XYZ 助手已完成知识结构化；任何贡献或项目决策之前仍需人工审查。",
  "Structured draft completed at the human-review boundary; no project mutation occurred.": "结构化草稿已在人工审查边界完成，没有发生项目修改。",
  "Review the knowledge before deciding how the project should change.": "先审阅知识，再决定项目应如何改变。",
  "The verified local realization is evidence. The KPR carries human intent, expected behavior, and boundaries—not project-authoritative code.": "通过验证的本地实现是证据。KPR 传递人的意图、期望行为与边界，而不是具有项目权威性的代码。",
  "Agent structured · human review required": "Agent 已结构化整理 · 需要人工审阅",
  "Decision brief · knowledge before code": "决策简报 · 知识先于代码",
  "Source application": "来源应用",
  "Source state": "来源状态",
  "Verified user-local change": "已验证的用户本地修改",
  "Knowledge package": "知识包",
  "expected behaviors": "项期望行为",
  "Current decision": "当前待决事项",
  "Review intent and evidence; project implementation is undecided": "审阅意图与证据；项目实现方式尚未决定",
  "Local realization change": "本地实现变更",
  "Rollback checkpoint": "回滚检查点",
  "Roll back this local change": "回滚这项本地修改",
  "Knowledge to review": "待审阅知识",
  "Human intent translated by the XYZ Agent": "由 XYZ 助手整理的人类意图",
  "Problem": "问题",
  "Expected behavior": "期望行为",
  "Acceptance boundary": "验收边界",
  "Explicit limitations": "明确局限",
  "Evidence and provenance": "证据与来源追踪",
  "What was observed, and where it came from": "观察到了什么，以及知识来自哪里",
  "Verified evidence": "已验证证据",
  "Human request issued through the XYZ Agent": "人通过 XYZ 助手发起需求",
  "Agent-structured intent and acceptance boundary": "由 Agent 结构化整理意图与验收边界",
  "Verified user-side checkpoint": "已验证的用户侧检查点",
  "Human review boundary": "人工审阅边界",
  "The XYZ Agent has structured the contribution. A person still decides what it means, whether it should proceed, and how the project may implement it.": "XYZ 助手已经完成贡献知识的结构化整理。其含义、是否继续推进，以及项目如何实现，仍由人决定。",
  "Contribution authority": "贡献权限边界",
  "Local behavior": "本地行为",
  "Verified": "已验证",
  "Project code": "项目代码",
  "Not authorized": "未获授权",
  "Merge / adoption": "合并／采纳",
  "Structured by": "结构化整理者",
  "Enabled": "已启用",
  "Disabled": "未启用",
  "theme": "主题",
  "fontSize": "字号",
  "interactiveSidebar": "交互式侧边栏",
  "clockWidget": "时钟组件",
  "structuredHeadlines": "结构化标题",
  "neutral": "中性",
  "blue": "蓝色",
  "The minimal Agent Demo has no dedicated surface for inspecting and invoking software capabilities.": "最小版 Agent Demo 缺少用于检查与调用软件能力的专用界面。",
  "A terminal-style sidebar appears on the right.": "右侧显示终端风格的侧边栏。",
  "The central conversation remains usable.": "中央对话区保持可用。",
  "Restoring the checkpoint removes the sidebar.": "恢复检查点会移除该侧边栏。",
  "Sidebar is visible and interactive.": "侧边栏可见且可以交互。",
  "Conversation content is not covered.": "对话内容没有被遮挡。",
  "One-step rollback restores the previous realization.": "一步回滚即可恢复此前的本地实现。",
  "The reference typography and neutral accent are less readable and less aligned with this user's preference.": "参考字号与中性色强调不够易读，也不符合当前用户的偏好。",
  "Application text uses a 16px base size.": "应用文本使用 16px 基础字号。",
  "The local accent becomes blue.": "本地强调色变为蓝色。",
  "The project reference remains neutral and 14px.": "项目参考实现仍保持中性色与 14px 字号。",
  "The active realization reports 16px.": "当前本地实现显示为 16px。",
  "Blue theme tokens are visible.": "蓝色主题变量已经生效。",
  "Reset restores the reference presentation.": "重置后恢复参考呈现。",
  "The Agent Demo user wants a lightweight time reference already available in another application surface.": "Agent Demo 用户希望复用另一个应用界面中已有的轻量时间参考。",
  "A clock widget appears in Agent Demo.": "Agent Demo 中显示时钟组件。",
  "The capability is reused without coupling the two applications.": "复用该能力，但不耦合两个应用。",
  "Rollback removes only the clock change.": "回滚只移除时钟修改。",
  "Clock is visible.": "时钟可见。",
  "Conversation and sidebar remain intact.": "对话区与侧边栏保持完整。",
  "Checkpoint rollback restores the prior realization.": "检查点回滚会恢复此前的本地实现。",
  "A known user preference should remain consistent when the user enters another Agentic Software application.": "用户进入另一个 Agentic Software 应用时，已知的用户偏好应保持一致。",
  "Daily News uses a 16px base size.": "每日新闻使用 16px 基础字号。",
  "Its accent becomes blue.": "其强调色变为蓝色。",
  "The reference default remains unchanged.": "参考默认值保持不变。",
  "Preference is visible in Daily News.": "每日新闻中可以看到该偏好。",
  "News data and notes are unchanged.": "新闻数据与笔记保持不变。",
  "Raw feed headlines are inconsistent and make rapid comparison difficult.": "原始信息流标题结构不一致，难以快速比较。",
  "Each visible title follows a consistent news-element structure.": "每个可见标题都遵循一致的新闻要素结构。",
  "Scores, authors, sources, and timestamps remain visible.": "评分、作者、来源与时间戳保持可见。",
  "The original titles remain recoverable.": "原始标题仍可恢复。",
  "Structured titles are visible.": "结构化标题可见。",
  "Metadata is preserved.": "元数据得到保留。",
  "Rollback restores the original headlines.": "回滚会恢复原始标题。",
  "The user-local checkpoint can restore the exact prior realization.": "用户本地检查点可以精确恢复此前的实现。",
  "The public reference configuration remains unchanged.": "公共参考配置保持不变。",
  "Evidence covers this local reference-application scenario only.": "证据只覆盖当前本地参考应用场景。",
  "This KPR draft transfers knowledge; it does not authorize project code, merge, or adoption.": "这份 KPR 草稿用于传递知识，不授权项目代码修改、合并或采纳。"
};

function interpolate(template: string, values?: Record<string, string | number>): string {
  if (!values) return template;
  return Object.entries(values).reduce(
    (result, [key, value]) => result.replaceAll(`{${key}}`, String(value)),
    template
  );
}

interface LanguageValue {
  language: Language;
  t: (english: string, values?: Record<string, string | number>) => string;
}

const LanguageContext = createContext<LanguageValue>({ language: "en", t: (english, values) => interpolate(english, values) });

export function LanguageProvider({ language, children }: { language: Language; children: ReactNode }) {
  const t = (english: string, values?: Record<string, string | number>) =>
    interpolate(language === "zh-CN" ? zh[english] ?? english : english, values);
  return <LanguageContext.Provider value={{ language, t }}>{children}</LanguageContext.Provider>;
}

export function useI18n() {
  return useContext(LanguageContext);
}
